import { Refresh } from '@browser/Browser';
import CorporateNavigation from '@common/Components/CorporateNavigation.vue';
import { MonthPickerDialogViewModel } from '@common/Components/MonthPickerDialog';
import MonthPickerDialog from '@common/Components/MonthPickerDialog.vue';
import { MonthYear, MonthYearHelpers, ValidationError } from '@common/types';
import { ICommandStatus } from '@cqrs/cqrs';
import { ICommandBase } from '@Quest/cqrs';
import { UpdatePortfolioSettingsCommandV1 } from '@Quest/Portfolios/Domain/commands-core';
import PortfoliosCommands from '@Quest/Portfolios/Domain/commands-vue-component';
import PortfoliosQueries from '@Quest/Portfolios/Domain/queries-vue-component';
import { LinkableItemReadModel, PortfolioSettingsReadModel } from '@Quest/Portfolios/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        CorporateNavigation, MonthPickerDialog
    }
})
export default class PortfolioSettingsPage extends mixins(PortfoliosQueries, PortfoliosCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId(): number { return Number.parseInt(this.$route.params.tchProjectId); }
    get strategyId(): string { return this.rm?.StrategyId }


    rm: PortfolioSettingsReadModel | null = null;
    name: string | null = null;
    description: string | null = null;
    benefitsConfidenceDate: MonthYear | null = null;
    errors: ValidationError[] = [];
    benefitsConfidenceDateMonthPicker = new MonthPickerDialogViewModel();

    get nameError(): string | null { return this.errors?.find(error => error.Context === "Name")?.Error ?? null; }
    get benefitsConfidenceDateLabel(): string | null { return MonthYearHelpers.toMonthYearLongString(this.benefitsConfidenceDate); }

    toggleLinkage(i: LinkableItemReadModel)
    {
        i.IsLinked = !i.IsLinked;
    }



    showBenefitsConfidenceDateMonthPicker()
    {
        this.benefitsConfidenceDateMonthPicker.show(this.benefitsConfidenceDate, "End of benefits confidence", false);
    }

    handleUpdateBenefitsConfidenceDate(date: MonthYear | null)
    {
        this.benefitsConfidenceDate = date;
    }

    handleUpdatePortfolioSettingsCommand()
    {
        this.errors = [];

        const excludedResourceIds = this.rm!.Resources.filter(a => !a.IsLinked).map(a => a.Id);
        const excludedRevenueIds = this.rm!.Revenues.filter(a => !a.IsLinked).map(a => a.Id);
        const excludedExpenseIds = this.rm!.Expenses.filter(a => !a.IsLinked).map(a => a.Id);
        const excludedCapexIds = this.rm!.Capex.filter(a => !a.IsLinked).map(a => a.Id);

        this.invokeUpdatePortfolioSettingsCommandV1(this.workspaceId, this.rm.Id, this.name!, this.description, this.benefitsConfidenceDate,
            excludedResourceIds, excludedRevenueIds, excludedExpenseIds, excludedCapexIds);
    }

    mounted()
    {
        document.title = "Portfolio | TransparentChoice";
        this.runPortfolioSettingsQueryV1(this.workspaceId, this.tchProjectId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "PortfolioSettingsReadModel")
        {
            const rm = model as PortfolioSettingsReadModel;
            this.name = rm.Name;
            this.description = rm.Description;
            this.benefitsConfidenceDate = MonthYearHelpers.copyNullable(rm.BenefitsConfidenceDate); 

            this.rm = rm;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
    {
        if (UpdatePortfolioSettingsCommandV1.matchType(cmd))
        {
            Refresh();
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (UpdatePortfolioSettingsCommandV1.matchType(status.Command))
        {
            this.errors = status.ValidationErrors;
            alert("Sth went wrong");
        }
    }
}